var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-container-status"},[_c('h4',[_vm._v("Status naprawy:")]),(!_vm.getIsFinishedStatus)?_c('h2',[_vm._v(_vm._s(_vm.getStatus))]):_c('h2',{staticClass:"done"},[_vm._v(_vm._s(_vm.getStatus))]),(!_vm.getIsFinishedStatus)?_c('i',{staticClass:"far fa-spinner fa-pulse"}):_c('i',{staticClass:"far fa-check-circle done"})])
}
var staticRenderFns = []

export { render, staticRenderFns }